import { render, staticRenderFns } from "./Edificio.vue?vue&type=template&id=cb312c30&"
import script from "./Edificio.vue?vue&type=script&lang=js&"
export * from "./Edificio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports